import { useMemo } from 'react';

import { useAuth } from '@/hooks/useAuth';

/**
 * Page-level access gate for the ShipEdge Reports admin pages.
 * Phase 15 Day 7. Lives in its own file so `_chrome.tsx` exports
 * components only (Vite's react-refresh rule).
 */
export function useShipedgeAdminGate(): { canAccess: boolean } {
  const { state } = useAuth();
  const canAccess = useMemo(() => {
    if (state.status !== 'authenticated') return false;
    return ['visionary', 'integrator'].includes(state.me.membership.role);
  }, [state]);
  return { canAccess };
}
